import type { KYCQuestionDefinition } from '@anchorage/graphql/generated';
import { parseSanitize } from '@anchorage/utils';
import { FormCheckboxGroup, reactHookForm, useWatch } from '@latitude/form';
import { useEffect, useState } from 'react';

// Option labels are sanitized HTML and may contain bullet lists.
const CONTAINER_CLASSES =
  'mt-spacing-sys-spacing-4 flex flex-col gap-spacing-sys-spacing-4 leading-sys-line-height-24 [&_li]:my-spacing-sys-spacing-8 [&_ul]:mx-spacing-sys-spacing-24 [&_ul]:mt-spacing-sys-spacing-8 [&_ul]:list-disc';

type Props = {
  question: KYCQuestionDefinition;
  isDisabled?: boolean;
  trackFn?: (questionId: string) => void;
};

function CheckboxComponent({
  question,
  isDisabled = false,
  trackFn = () => {},
}: Props) {
  const { control } = reactHookForm.useFormContext();

  // track change
  const [userClicked, setUserClicked] = useState(false);
  const [prevValue, setPrevValue] = useState<string | string[] | undefined>('');
  const selectedOption = useWatch({
    control,
    name: `${question.id}.options`,
  }) as string[] | string;
  useEffect(() => {
    setPrevValue(selectedOption);
    if (!userClicked) {
      return;
    }
    if (selectedOption !== prevValue) {
      trackFn?.(question.id);
    }
  }, [selectedOption, userClicked, question.id, prevValue, trackFn]);

  return (
    <div className={CONTAINER_CLASSES} onClick={() => setUserClicked(true)}>
      <FormCheckboxGroup
        control={control}
        options={
          question?.options?.map((option) => ({
            label: parseSanitize(option.text) ?? '',
            value: option.id,
            disabled: isDisabled,
            // make all checkboxes align to the top
            wrapperClassname: '!items-start',
          })) || []
        }
        name={`${question.id}.options`}
      />
    </div>
  );
}

export { CheckboxComponent };
